import React from "react";
import { withAuthenticationRequired, withAuth0 } from "@auth0/auth0-react";
import Loader from "../../components/Loader";

class Default extends React.Component {

  constructor({ match, ...props }) {
    super(...arguments);
  }
  async componentDidMount() {
    const { user, isAuthenticated } = this.props.auth0;
    if (isAuthenticated) {
      localStorage.removeItem("pdUserRole");
      if (user['https://propertydek.com/roles'].indexOf('Security') > -1) {
        localStorage.setItem("pdUserRole", 'Security');
        this.props.history.push('/security/journal/list');
      } else if (user['https://propertydek.com/roles'].indexOf('Technician') > -1) {
        localStorage.setItem("pdUserRole", 'Technician');
        this.props.history.push('/dashboard');
      } else {
        localStorage.setItem("pdUserRole", 'Other');
        this.props.history.push('/dashboard');
      }

    }
  }

  render() {

    return (
      <React.Fragment>
        <Loader />
      </React.Fragment>
    );
  }

}
export default withAuthenticationRequired(withAuth0(Default), {
  onRedirecting: () => <Loader />,
});